"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const faqs = [{
    question: "What is cloud accounting and how does it benefit my business?",
    answer: "Cloud accounting allows you to access your financial data from anywhere with an internet connection. It provides real-time insights, automatic backups, seamless collaboration with your accountant, and reduces the need for manual data entry through bank feeds and integrations."
  }, {
    question: "Which cloud accounting software is right for my business?",
    answer: "The best software depends on your business size, industry, and specific needs. Xero is ideal for small to medium businesses, QuickBooks offers comprehensive features for various industries, FreeAgent suits freelancers and contractors, while Sage Cloud caters to growing businesses. We can help you choose the most suitable solution."
  }, {
    question: "Is my financial data secure in the cloud?",
    answer: "Yes, cloud accounting platforms use bank-level encryption, multi-factor authentication, and secure data centers with regular backups. Your data is often more secure in the cloud than on local computers, as providers invest heavily in security infrastructure and compliance with data protection regulations."
  }, {
    question: "How much does cloud accounting cost?",
    answer: "Pricing varies by software and features needed. Most platforms offer tiered subscriptions starting from £10-30 per month for basic plans, with advanced features costing more. Many solutions offer free trials, and the efficiency gains often offset the subscription costs through time savings and reduced errors."
  }, {
    question: "Can I integrate my existing software with cloud accounting?",
    answer: "Most cloud accounting platforms offer extensive integrations with popular business tools including payment processors, CRM systems, inventory management, and e-commerce platforms. This creates a seamless ecosystem where data flows automatically between systems, reducing manual entry and improving accuracy."
  }, {
    question: "What support do you provide for cloud accounting implementation?",
    answer: "We offer comprehensive support including initial setup, data migration from your current system, staff training, ongoing technical support, and regular reviews to ensure you're maximizing the software's capabilities. Our team is always available to answer questions and help optimize your processes."
  }];
  return <section id="frequently-asked-questions" className="bg-background py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <div className="mb-12 text-center">
            <h2 className="mb-4 font-display text-foreground">
              Frequently Asked Questions
            </h2>
            <p className="text-muted-foreground mx-auto max-w-2xl">
              Find answers to common questions about cloud accounting solutions
              and how we can help transform your business finances.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-0">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border transition-colors duration-200 hover:bg-surface/50">
                <AccordionTrigger className="px-6 text-left text-foreground hover:no-underline">
                  <span className="font-semibold">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="px-6 text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}